export const ADD = 'todos/ADD';
export const TOGGLE = 'todos/TOGGLE';
export const CHANGE_FILTER = 'todos/CHANGE_FILTER';
